<template>
    <v-app>
    
        <portal-sysbar></portal-sysbar>
    
        <div class="main-content">
    
            <portal-aside></portal-aside>
    
            <portal-title :title="$t('message.aside.alert', { value: 'default' })">
    
            </portal-title>
    
            <portal-breadcumb></portal-breadcumb>
    
    
    
            <div class="content">
    
                <v-row>
    
                    <div class="mt-3">
    
                        <v-card width="250">
    
                            <v-list color="#7FC7B2">
    
                                <router-link to="/alert/battery" exact-path>
    
                                    <v-list-item link>
    
                                        <v-list-item-icon>
    
                                            <v-icon dense color="#00475A"> mdi-battery </v-icon>
    
                                        </v-list-item-icon>
    
                                        <v-list-item-title class="filter-item-title">
    
                                            {{ $t("message.alert.battery", { value: "default" }) }}
    
                                        </v-list-item-title>
    
                                    </v-list-item>
                                </router-link>

                                <router-link to="/alert/sr" exact-path>
                                <v-list-item link>
                                    <v-list-item-icon>
                                         <img src="/static/csign.svg" /> 
                                    </v-list-item-icon>

                                    <v-list-item-title class="filter-item-title">

                                        {{this.$t('message.alert.sralert', { value: 'default' })}}

                                    </v-list-item-title>

                                </v-list-item>

                            </router-link>

                            <!--qutoation alert-->
                            <router-link to="/alert/quotation" exact-path>
                                <v-list-item link>
                                    <v-list-item-icon>
                                         <img src="/static/quotation_alert.svg" /> 
                                    </v-list-item-icon>

                                    <v-list-item-title class="filter-item-title">

                                        {{this.$t('message.alert.quotation', { value: 'default' })}}

                                    </v-list-item-title>

                                </v-list-item>

                            </router-link>

    
 <!--                               
    
                      <router-link to="/alert/poi">
    
                        <v-list-item link>
    
                          <v-list-item-icon>
    
                            <v-icon dense color="#00475A"> mdi-train </v-icon>
    
                          </v-list-item-icon>
    
                          <v-list-item-title class="filter-item-title">
    
                            Entrees et sorties locomotives
    
                          </v-list-item-title>
    
                        </v-list-item>
    
                      </router-link>
    
                     -->
    
                            </v-list>
                        </v-card>
                    </div>
                    <v-col>
                        <router-view></router-view>  
                    </v-col>
    
                </v-row>
    
            </div>
    
        </div>
    
    </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
export default {
    title: "My alerts",
    name: "AlertPage",
    components: {
        PortalSysbar,
        PortalAside,
        PortalTitle,
        PortalBreadcumb,
    },
};
</script>

<style scoped>
.filter-item-title {
    font: normal bolder 16px Calibri;
    text-transform: uppercase;
    color: #00475a;
    white-space: initial;
}

.router-link-active>div {
    color: #fff;
    background-color: #6db7a2;
}

.disclamer{
    margin-top: 10px;
    text-transform : uppercase;
    font-weight: bolder;
}
</style>